export const removeWords = (inputString, wordsToRemove) => {
  const removeSet = new Set(wordsToRemove.map((word) => word.toLowerCase()));
  return inputString
    .split(' ')
    .filter((word) => !removeSet.has(word.toLowerCase()))
    .join(' ');
};

export const removeDuplicateWords = (inputString) => {
  const words = inputString.split(/\s+/);
  const uniqueWords = new Set();

  return words
    .filter((word) => {
      const lowercased = word.toLowerCase();
      if (!uniqueWords.has(lowercased)) {
        uniqueWords.add(lowercased);
        return true;
      }
      return false;
    })
    .join(' ');
};

export const preparePostalAddress = (addressData = {}) => {
  const branchOfficePostalNames = ['H.O', 'S.O', 'B.O'];
  const poles = ['East', 'West', 'North', 'South'];

  const {
    donorName_en = '',
    donorAddress_en = '',
    village = '',
    post_office = '',
    pincode = '',
    taluk = '',
    district = '',
    state = '',
    donorPhone = '',
  } = addressData;

  const mobile = donorPhone?.trim() ? `, Mobile: ${donorPhone}` : '';
  const doorNumbers = donorAddress_en ? `, ${donorAddress_en}` : '';

  const address = `${removeWords(village, poles)}, ${removeWords(taluk, poles)}, ${district}, ${state}`;

  return `${donorName_en}${doorNumbers}, ${removeDuplicateWords(address)}, PO: ${removeWords(post_office, branchOfficePostalNames)}, Pincode: ${pincode}${mobile}`;
};

export const searchDonors = (donorsArray, searchTerm) => {
  if (!Array.isArray(donorsArray)) return [];
  const searchValue = String(searchTerm);
  return donorsArray.filter(
    (donor) =>
      donor.donorId === Number(searchValue) || donor.donorPhone === searchValue
  );
};

export const searchForRejectReasons = (rejectReasonsArray, searchTerm) => {
  if (!Array.isArray(rejectReasonsArray)) return [];
  const searchValue = String(searchTerm);
  return rejectReasonsArray.filter(
    (donor) =>
      donor.donorId === Number(searchValue) && donor.reasonType === 'postal'
  );
};

export const isPostalSentForYear = (searchTerm, postalAddress) => {
  if (!Array.isArray(postalAddress)) return false;
  const searchValue = Number(searchTerm);
  const out = postalAddress.filter((donor) => donor.donorId === searchValue);
  return out.length !== 0;
};

export const islocalLocality = (searchTerm, masterAddress) => {
  if (!Array.isArray(masterAddress)) return '';
  const searchValue = Number(searchTerm);
  const out = masterAddress.filter((donor) => donor.donorId === searchValue);
  return out.length !== 0 ? out[0]?.village : '';
};

export const processdonors = (donors, addressMap, masterAddressMap) => {
  return (
    donors?.map((donor) => ({
      ...donor,
      address: addressMap.get(donor.donorId)
        ? preparePostalAddress(addressMap.get(donor.donorId))
        : masterAddressMap.get(donor.donorId)
          ? preparePostalAddress(masterAddressMap.get(donor.donorId))
          : '',
    })) || []
  );
};

export const findPageNumber = (value, data = {}) => {
  let numbers = [];
  for (let key in data) {
    if (data[key].split(',').map(Number).includes(value)) {
      numbers.push(key);
    }
  }
  return numbers.join(', ');
};

export const ivrStatus = (array1 = [], array2 = [], masterMobileIvr = []) => {
  if (!Array.isArray(masterMobileIvr)) return [];
  const phones = [...array1, ...array2].map((item) => item.phone);
  const searchMobile = [...new Set(phones)];
  return searchMobile.length !== 0
    ? masterMobileIvr.filter((item) => item.mobile === searchMobile[0])
    : [];
};

export const displayCurrentYear = (time) => {
  return time?.appYear;
};

export const formatDate = (inputDate) => {
  if (!inputDate || typeof inputDate !== 'string') {
    return 'Invalid date format';
  }

  const dateRegex = /^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2}):(\d{2}))?/;
  const match = inputDate.match(dateRegex);

  if (!match) {
    return 'Invalid date format';
  }

  const year = match[1];
  const month = parseInt(match[2], 10) - 1;
  const day = match[3];
  const hour = match[4] ? parseInt(match[4], 10) : null;
  const min = match[5] || '00';
  const date = new Date(year, month, day);

  const options = { day: '2-digit', month: 'long', year: 'numeric' };
  let formatted = date.toLocaleDateString('en-GB', options);

  if (hour !== null) {
    const period = hour >= 12 ? 'PM' : 'AM';
    const h12 = hour % 12 || 12;
    formatted += `, ${h12}:${min} ${period}`;
  }

  return formatted;
};

export const generateRandomBase64 = (length = 16) => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomValues = crypto.getRandomValues(new Uint8Array(length));

  return Array.from(randomValues)
    .map((byte) => chars[byte % chars.length])
    .join('');
};
